import { clone } from 'ramda';
import { getIndexedContent } from '../reducers/utils';

export default function buildContent(group) {
  const items = clone(group.items);
  const content = Object.assign({}, getIndexedContent(items, true));
  return content;
}
